<template>
	<div>
		<v-menu offset-y>
			<template v-slot:activator="{ on, attrs }">
				<v-btn v-bind="attrs" v-on="on" class="text-capitalize" icon>
					<v-icon>mdi-dots-vertical</v-icon>
				</v-btn>
			</template>
			<v-list dense>
				<template v-for="(item, index) in menuItems">
					<v-list-item :key="index" @click="handleMenuClick(item.action)" link class="pr-0">
						<v-list-item-icon class="mr-4">
							<v-icon>{{ item.icon }}</v-icon>
						</v-list-item-icon>
						<v-list-item-title class="body-2">{{ item.title }}</v-list-item-title>
						<v-divider inset></v-divider>
					</v-list-item>
					<v-divider v-if="index === menuItems.length - 2" :key="item.title"></v-divider>
				</template>
			</v-list>
		</v-menu>
		<slot-dialog v-model="dialogOpen" :title="dialogTitle" :dialogWidth="customDialogWidth" @close="closeDialog">
			<div v-if="dialogType === 'profile'">
				<my-profile-viewer-fields :value="currentUser"> </my-profile-viewer-fields>
			</div>
			<div v-if="dialogType === 'settings'">
				<settings-tabs-management />
			</div>
		</slot-dialog>
	</div>
</template>

<script>
// globals
// locals
import i18n from './dictionary.js';
// components
import SlotDialog from '@/components/base/slotDialog/SlotDialog.vue';
import SettingsTabsManagement from './settingsTabs/SettingsTabsManagement.vue';
import MyProfileViewerFields from '@/components/models/viewerFields/myProfileViewerFields/MyProfileViewerFields.vue';
// store
import { mapState, mapActions } from 'pinia';
import { useAuthStore } from '@/plugins/auth/store';

export default {
	name: 'AppBarMenu',
	components: { SlotDialog, SettingsTabsManagement, MyProfileViewerFields },
	props: {
		currentUser: {
			type: Object,
			required: true,
		},
		dialogWidth: {
			type: Number,
			default: 800,
		},
	},
	i18n,
	data() {
		return {
			dialogOpen: false,
			dialogType: '',
			dialogTitle: '',
			customDialogWidth: this.dialogWidth,
		};
	},
	computed: {
		menuItems() {
			const items = [
				{ title: this.$t('$global.actions.myProfile'), icon: 'mdi-card-account-details-outline', action: 'profile' },
			];
			if (this.isAdmin)
				items.push({ title: this.$t('$global.actions.settings'), icon: 'mdi-cog-outline', action: 'settings' });
			items.push({ title: this.$t('$global.actions.logout'), icon: 'mdi-logout', action: 'logout' });
			return items;
		},
		...mapState(useAuthStore, ['isAdmin']),
	},
	methods: {
		...mapActions(useAuthStore, ['logout']),
		handleMenuClick(action) {
			const actionHandles = {
				logout: async () => {
					await this.logout();
				},
				settings: () => {
					this.dialogType = 'settings';
					this.dialogTitle = this.$t('actions.settings');
					this.customDialogWidth = 1000;
					this.openDialog();
				},
				profile: () => {
					this.dialogType = 'profile';
					this.dialogTitle = this.$t('actions.myProfile');
					this.customDialogWidth = 700;
					this.openDialog();
				},
			};

			const selectedActionHandle = actionHandles[action];
			if (selectedActionHandle) selectedActionHandle();
		},
		openDialog() {
			this.dialogOpen = true;
		},
		closeDialog() {
			this.dialogType = null;
			this.dialogOpen = false;
		},
	},
};
</script>
